import React, { useCallback, useEffect, useRef } from "react";
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";

import { useGameContext } from "../context/useGameContext";
import { unscaleLat, unscaleLng } from "../utilities/coordinateScaling";

const GoogleStreetView = () => {
  const { coor } = useGameContext();

  const { isLoaded } = useJsApiLoader({
    id: "map-script",
    googleMapsApiKey: `${process.env.REACT_APP_GOOGLE_API_KEY}`,
  });

  const panoramaRef = useRef<google.maps.StreetViewPanorama | null>(null);

  const onLoad = useCallback(() => {
    if (!panoramaRef.current) {
      panoramaRef.current = new window.google.maps.StreetViewPanorama(
        document.getElementById("map") as HTMLElement,
        {
          position: {
            lat: unscaleLat(coor.lat),
            lng: unscaleLng(coor.lng),
          },
          linksControl: false,
          clickToGo: false,
          enableCloseButton: false,
          disableDefaultUI: true,
          zoomControl: false,
          visible: true,
          scrollwheel: false,
          addressControl: false,
          showRoadLabels: false,
          pov: { heading: 135.65, pitch: -12.15 },
          panControl: true,

          panControlOptions: {
            position: google.maps.ControlPosition.LEFT_CENTER,
          },
          imageDateControl: false,
          disableDoubleClickZoom: true,
          motionTracking: false,
          motionTrackingControl: false,
        }
      );
    }
  }, [coor.lat, coor.lng]);

  const removeElement = () => {
    const interval = setInterval(() => {
      const element = document.querySelector('img[alt="Google"]');
      if (element) {
        element.parentElement?.remove();
        clearInterval(interval);
      }
    }, 100);
  };

  useEffect(() => {
    if (isLoaded) {
      onLoad();
      removeElement();
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      if (
        (event.key === "ArrowUp" ||
          event.key === "ArrowDown" ||
          event.key === "ArrowLeft" ||
          event.key === "ArrowRight" ||
          event.key === "+" ||
          event.key === "=" ||
          event.key === "_" ||
          event.key === "-") &&
        !event.metaKey &&
        !event.altKey &&
        !event.ctrlKey
      ) {
        event.stopPropagation();
      }
    };

    window.addEventListener("keydown", handleKeyDown, { capture: true });

    // Mobilne przeglądarki pokazują/chowają pasek adresu przy scrollu,
    // co zmienia dostępną wysokość (100dvh) - panorama tego sama nie
    // wykrywa i trzeba ją jawnie przemierzyć, inaczej zostaje puste pole
    const handleResize = () => {
      if (panoramaRef.current) {
        window.google.maps.event.trigger(panoramaRef.current, "resize");
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("keydown", handleKeyDown, { capture: true });
      window.removeEventListener("resize", handleResize);
      panoramaRef.current = null;
    };
  }, [isLoaded, onLoad]);

  return (
    <>
      {isLoaded ? (
        <GoogleMap
          id="map"
          onLoad={onLoad}
          // onClick={(e: any) => console.log(e)}
          options={{
            disableDefaultUI: true,
          }}
        ></GoogleMap>
      ) : (
        <>
          <div className="loading">Ładowanie mapy...</div>
        </>
      )}
    </>
  );
};

export default React.memo(GoogleStreetView);
